module.exports = __webpack_public_path__ + "img/wallet_02_yourgateway_2.ec00171e.png";